<template>
  <modal
    ref="modal"
    :width="300"
    :height="400"
    :click-to-close="false"
    name="email-modal"
    class="email-modal"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="close-icon-container" @click="closeEmailModal">
      <span class="icon">
        <font-awesome-icon :icon="['far', 'times-circle']" class="fa-2x" />
      </span>
    </div>
    <CongratsMessage
      :message="message"
      :description="description"
      :icon="icon"
    />
    <div
      v-if="email && email !== 'anonymous@pedalsure.com'"
      class="form-group control has-icons-right"
    >
      <ValidationProvider
        ref="emailObserver"
        v-slot="{ errors }"
        mode="lazy"
        rules="required|email"
      >
        <input
          id="email"
          v-model="email"
          :class="{ 'is-danger': errors[0] }"
          type="text"
          class="input"
          required
        />
        <label class="form-control-placeholder" for="email"> Email </label>
        <span v-if="errors[0]" class="icon is-danger is-small is-right">
          <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
        </span>
        <span :class="{ 'is-danger': errors[0] }" class="help">{{
          errors[0]
        }}</span>
      </ValidationProvider>
    </div>
    <div
      v-if="email && email !== 'anonymous@pedalsure.com'"
      class="has-text-centered"
    >
      <button class="button is-outlined" @click="sendQuoteEmail">
        <span> Email quote </span>
      </button>
    </div>
    <div v-if="!email" class="has-text-centered">
      <button class="button is-outlined" @click="continueToQuote">
        <span> Return to my quote </span>
      </button>
    </div>
  </modal>
</template>

<script>
import CongratsMessage from '@/components/common/CongratsMessage'

export default {
  name: 'EmailModal',
  components: { CongratsMessage },
  data() {
    return {
      message: 'Email me my quote',
      description: '',
      icon: ['far', 'check-circle'],
      email: '',
    }
  },
  computed: {},
  mounted() {},
  methods: {
    beforeOpen(event) {
      if (event.params) {
        const { message, description, icon, email } = event.params
        this.message = message
        this.description = description
        this.icon = icon
        this.email = email
      }
    },
    beforeClose(event) {},
    closeEmailModal() {
      this.$modal.hide('email-modal')
    },
    sendQuoteEmail() {
      // TODO: Decide how to send the quote
    },
    continueToQuote() {
      this.$modal.hide('email-modal')
    },
  },
}
</script>

<style lang="scss">
.email-modal {
  .close-icon-container {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .v--modal-box {
    @include tablet {
      padding: 50px;
    }
  }
}
</style>
